import React, { MutableRefObject, useEffect } from 'react';

function useOnClickOutside(
  refs: Array<MutableRefObject<HTMLElement | undefined | null>>,
  handler: (event: PointerEvent) => void,
  targetElement?: React.RefObject<HTMLElement>,
  exceptSelectors: string[] = [],
  isActive = true,
): void {
  useEffect(() => {
    if (!isActive || !handler) {
      return;
    }

    const listener = (event: PointerEvent): void => {
      const target = event.target as HTMLElement;
      const hasNoElement = refs.every((ref) => !ref?.current);
      const containsTarget = refs.some(
        (ref) => !!ref?.current?.contains(target),
      );
      const exceptContainsTarget = event
        .composedPath()
        .some((eventTarget: any) =>
          exceptSelectors.some((selector) => eventTarget.matches?.(selector)),
        );

      if (
        hasNoElement ||
        containsTarget ||
        exceptContainsTarget ||
        targetElement?.current?.contains(target)
      ) {
        return;
      }
      handler(event);
    };

    document.addEventListener('pointerdown', listener);

    return () => {
      document.removeEventListener('pointerdown', listener);
    };
  }, [refs, targetElement, handler, exceptSelectors, isActive]);
}

export default useOnClickOutside;
